import React from "react"

import { GrowthChange, getGrowthChange, toStatNumber } from "../common/growthChange"

const CommunityMonthlyStats = ({ community }) => {
  const statsToShow = [
    {
      name: "Views /mo",
      stat: community.views,
      prev: community.viewsPrev,
    },
    {
      name: "Visitors /mo",
      stat: community.visitors,
      prev: community.visitorsPrev,
    },
    {
      name: "Referrals /mo",
      stat: community.redirects,
      prev: community.redirectsPrev,
    },
  ]

  const hasAnyStat = statsToShow.some((item) => toStatNumber(item.stat) > 0)
  if (!hasAnyStat) return null

  return (
    <section aria-labelledby="community-stats">
      <div className="rounded-lg bg-white overflow-hidden shadow p-6">
        <div className="relative flex items-center">
          <h2
            className="text-base font-medium text-gray-900 bg-white"
            id="community-stats"
          >
            Monthly Stats
          </h2>
        </div>

        <div className="mt-2">
          <dl className="rounded-lg w-full sm:flex">
            {statsToShow.map((item) => {
              const change = getGrowthChange(item.stat, item.prev)
              return (
                <div key={item.name} className="p-0.5 flex-1 text-center flex flex-col items-center">
                  <dd className="text-lg font-semibold text-rose-500">
                    {item.stat}
                  </dd>
                  <dt className="text-sm font-normal text-gray-600">
                    {item.name}
                  </dt>
                  <GrowthChange change={change} className="mt-0.5 font-semibold text-xs opacity-75" />
                </div>
              )
            })}
          </dl>
        </div>
      </div>
    </section>
  )
}

export default CommunityMonthlyStats
